import * as React from "react";
import {match, Redirect, Switch} from "react-router";
import RestrictedRoute from "./route/RestrictedRoute";
import {UserPermission} from "../model/user/UserPermission";
import PartnerBrandCreate from "../components/admin/partnerBrands/PartnerBrandCreate";
import PartnerBrandUpdate from "../components/admin/partnerBrands/PartnerBrandUpdate";
import AccountsView from "../components/accounting/AccountsView";
import BillsView from "../components/accounting/BillsView";
import BillDetailsView from "../components/accounting/BillDetailsView";
import JournalView from "../components/accounting/JournalView";
import GeneralLedgerView from "../components/accounting/GeneralLedgerView";
import PartnerBrandWorkspaceContainer from "../components/v5/workspace/PartnerBrandWorkspaceContainer";

interface RouteProps {
	/**
	 * Route match url.
	 */
	match: match<any>;
}

/**
 * Contact router view.
 */
export default class PartnerBrandRouter extends React.PureComponent <RouteProps, {}> {
	allowedPermissions = [UserPermission.AdminAll, UserPermission.AdminPartnerBrands];

	render() {
		return (
			<Switch>
				<RestrictedRoute exact
								 path={this.props.match.url}
								 component={PartnerBrandWorkspaceContainer}
								 allowedPermissions={this.allowedPermissions}/>
				<RestrictedRoute exact
								 path={this.props.match.url + "/create"}
								 component={PartnerBrandCreate}
								 allowedPermissions={this.allowedPermissions}/>
				<RestrictedRoute path={this.props.match.url + "/:partnerBrandId/accounts"}
								 component={AccountsView}
								 allowedPermissions={this.allowedPermissions}/>
				<RestrictedRoute path={this.props.match.url + "/:partnerBrandId/journal"}
								 component={JournalView}
								 allowedPermissions={this.allowedPermissions}/>
				<RestrictedRoute path={this.props.match.url + "/:partnerBrandId/bills/:billId"}
								 component={BillDetailsView}
								 allowedPermissions={this.allowedPermissions}/>
				<RestrictedRoute path={this.props.match.url + "/:partnerBrandId/bills"}
								 component={BillsView}
								 allowedPermissions={this.allowedPermissions}/>
				<RestrictedRoute path={this.props.match.url + "/:partnerBrandId/general_ledger"}
								 component={GeneralLedgerView}
								 allowedPermissions={this.allowedPermissions}/>
				<RestrictedRoute path={this.props.match.url + "/:partnerBrandId"}
								 component={PartnerBrandUpdate}
								 allowedPermissions={this.allowedPermissions}/>
				<Redirect to={this.props.match.url}/>
			</Switch>
		)
	}
}
